// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-box {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center; /* Vertically center */
  /* border: 0.72px solid rgb(0, 81, 255); */
  /* margin-top: 40px; */

  /* border: 0.72px solid red; */
  width: 50%;
  height: 100vh;
  padding: 18px;
}

.login-box .logo-box {
  color: white;
  max-width: 100%;
  width: 400px;
  /* margin-bottom: 70px; */
  text-align: "center";
}

.logo-box img {
  max-width: 100%;
  height: auto;
  width: 400px; /* 20vw */
  /* border: 0.72px solid pink; */
}

.logo-box svg {
  max-width: 100%;
  height: auto;
  width: 400px;
  /* border: 0.72px solid pink; */
}

.login-box .login-form {
  color: white;
  max-width: 100%;
  min-width: 400px; /* 23vw */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  width: 400px;
  margin-top:12rem; /* 0.4vw */
  /* border: 0.72px solid pink; */
}

.custom-width {
  width: 100%;
  /* border: 0.72px solid red; */
  /* height: inherit; */
}

/* Forgot Password */
.custom-forgot-password {
  color: #ffffff !important;
  text-decoration: none !important;
  font-family: "Karla" !important;
  font-weight: 400 !important;
  font-size: 18px !important; /* 0.9vw */
  line-height: 21.5px !important; /* 1.1vw */
  background-color: transparent !important;
  padding: 0 !important;
  /* margin: 0 !important; */
  border: none !important;
  cursor: pointer;
}

.forgot-password-error {
  /* border: 0.72px solid red; */
  color: #e77b7b !important;
  text-align: justify !important;
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 18px !important; /* 0.9vw */
  line-height: 27px !important; /* 1.35vw */
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/styles/loginForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB,EAAE,sBAAsB;EAC3C,0CAA0C;EAC1C,sBAAsB;;EAEtB,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY,EAAE,SAAS;EACvB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB,EAAE,SAAS;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB,EAAE,UAAU;EAC5B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B,EAAE,UAAU;EACtC,8BAA8B,EAAE,UAAU;EAC1C,wCAAwC;EACxC,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B,EAAE,UAAU;EACtC,4BAA4B,EAAE,WAAW;AAC3C","sourcesContent":[".login-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center; /* Vertically center */\n  /* border: 0.72px solid rgb(0, 81, 255); */\n  /* margin-top: 40px; */\n\n  /* border: 0.72px solid red; */\n  width: 50%;\n  height: 100vh;\n  padding: 18px;\n}\n\n.login-box .logo-box {\n  color: white;\n  max-width: 100%;\n  width: 400px;\n  /* margin-bottom: 70px; */\n  text-align: \"center\";\n}\n\n.logo-box img {\n  max-width: 100%;\n  height: auto;\n  width: 400px; /* 20vw */\n  /* border: 0.72px solid pink; */\n}\n\n.logo-box svg {\n  max-width: 100%;\n  height: auto;\n  width: 400px;\n  /* border: 0.72px solid pink; */\n}\n\n.login-box .login-form {\n  color: white;\n  max-width: 100%;\n  min-width: 400px; /* 23vw */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n  width: 400px;\n  margin-top:12rem; /* 0.4vw */\n  /* border: 0.72px solid pink; */\n}\n\n.custom-width {\n  width: 100%;\n  /* border: 0.72px solid red; */\n  /* height: inherit; */\n}\n\n/* Forgot Password */\n.custom-forgot-password {\n  color: #ffffff !important;\n  text-decoration: none !important;\n  font-family: \"Karla\" !important;\n  font-weight: 400 !important;\n  font-size: 18px !important; /* 0.9vw */\n  line-height: 21.5px !important; /* 1.1vw */\n  background-color: transparent !important;\n  padding: 0 !important;\n  /* margin: 0 !important; */\n  border: none !important;\n  cursor: pointer;\n}\n\n.forgot-password-error {\n  /* border: 0.72px solid red; */\n  color: #e77b7b !important;\n  text-align: justify !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 400 !important;\n  font-size: 18px !important; /* 0.9vw */\n  line-height: 27px !important; /* 1.35vw */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
